import { jsx as _jsx } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
import { COMMERCE_WAITLIST_URL, getInAppPaymentsUrl } from 'pricing-pages-lib/utils/urls';
import { COMMERCE } from 'self-service-api/constants/EnrolledProductLines';
import UIButton from 'UIComponents/button/UIButton';
import { useAppSelector } from '../../reducers';
import { isAppAuthSelector } from '../../selectors/AuthSelectors';
import { isInUnitedStatesSelector } from '../../selectors/CountrySelectors';
import SignupButton from '../common/SignupButton';

const BringCommerceCTAs = () => {
  const isAppAuth = useAppSelector(isAppAuthSelector);
  const isInUs = useAppSelector(isInUnitedStatesSelector);
  const goToPaymentsUrl = getInAppPaymentsUrl();

  const handleJoinTheWaitlist = () => {
    getUsageTracker().track('externalLinkClick', {
      name: 'join-the-commerce-waitlist-link',
      url: COMMERCE_WAITLIST_URL
    });
  };

  const handleGoToPayments = () => {// Add tracking if Payments Page View tracking does not have referrer URL
    // getUsageTracker().track('externalLinkClick', {
    //   name: 'go-to-payments-link',
    //   url: goToPaymentsUrl,
    // });
  }; // For both public and in-app


  if (!isInUs) {
    return /*#__PURE__*/_jsx(UIButton, {
      use: "primary",
      href: COMMERCE_WAITLIST_URL,
      onClick: handleJoinTheWaitlist,
      "data-test-id": "commerce-join-the-waitlist",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricingPage.pages.commerce.joinTheWaitlist"
      })
    });
  } // Sign-up on public page


  if (!isAppAuth) {
    return /*#__PURE__*/_jsx(SignupButton, {
      sourceId: "pricing-pages-commerce-hub-page",
      use: "primary",
      productLine: COMMERCE
    });
  } // Go to payments zero state in-app


  return /*#__PURE__*/_jsx(UIButton, {
    use: "primary",
    href: goToPaymentsUrl,
    onClick: handleGoToPayments,
    "data-test-id": "commerce-go-to-payments-zero-state",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricingPage.pages.commerce.goToPayments"
    })
  });
};

export default BringCommerceCTAs;